<template>
  <div class="right-menu__feedback">
    <div class="right-menu__title">
      <h4>Обратный звонок</h4>
    </div>
    <div class="t-form">
      <div class="t-form__row">
        <div class="t-form__input" :class="{ error: errors.name }">
          <input
            type="text"
            id="feedback-name"
            v-model="data.name"
            @click="() => clearError('name')"
          />
          <label
            class="t-form__input-placeholder"
            :class="{ active: data.name }"
            for="feedback-name"
          >
            ФИО
            <span>*</span>
          </label>
          <span class="t-form__input-error">{{ errors.nameText }}</span>
        </div>
      </div>
      <div class="t-form__row">
        <div class="t-form__input" :class="{ error: errors.phone }">
          <input
            type="text"
            id="feedback-phone"
            @input="phoneFormat"
            :value="data.phone"
            maxlength="17"
            @click="() => clearError('phone')"
          />
          <label
            class="t-form__input-placeholder"
            :class="{ active: data.phone }"
            for="feedback-phone"
          >
            Номер телефона
            <span>*</span>
          </label>
          <span class="t-form__input-error">{{ errors.phoneText }}</span>
        </div>
      </div>
    </div>
    <p class="right-menu__text">
      Нажимая кнопку отправить, вы принимаете условия обработки персональных
      данных
    </p>
    <t-button type="small blue uppercase" :callback="submit"
      >Отправить</t-button
    >
  </div>
</template>

<script>
import Button from '@components/ui/button.vue';
import { mapMutations, mapState, mapActions } from 'vuex';
import Inputmask from 'inputmask';
import { setPhoneFormat, resetPhoneFormat } from '@src/js/inputMasks.js';

export default {
  components: {
    't-button': Button,
  },
  data: function () {
    return {
      data: {
        name: '',
        phone: '',
      },
      errors: {
        name: false,
        nameText: '',
        phone: false,
        phoneText: '',
      },
      errorsText: {
        empty: 'Поле не должно быть пустым',
        shortPassword: 'Пароль должен быть 6 и более символов',
        mismatchPassword: 'Введеные пароли не совпадают',
        incorrectPassword: 'Неверный пароль',
        incorrectUser: 'Пользователя с таким телефоном не существует',
      },
    };
  },
  computed: {
    ...mapState('api', ['callback']),
  },
  methods: {
    ...mapMutations('params', [
      'toogleCallBackForm',
      'toggleRightMenu',
      'toogleConfirmBlock',
    ]),
    ...mapActions('api', ['fetchRequest']),

    phoneFormat: function ({ target }) {
      this.data.phone = setPhoneFormat(target.value);
    },
    createPhone: function (value) {
      return resetPhoneFormat(value).slice(1);
    },

    validation: function () {
      let error = false;

      Object.keys(this.data).forEach((item) => {
        if (!this.data[item].trim()) {
          this.setErrors(item, 'empty');
          error: true;
        }
      });
    },
    setErrors: function (id, error) {
      this.errors[id] = true;
      this.errors[id + 'Text'] = this.errorsText[error];
    },

    clearError: function (id) {
      this.errors[id] = false;
    },
    form: function (data) {
      let _form = new FormData();
      Object.keys(data).forEach((item) => _form.append(item, data[item]));
      return _form;
    },

    submit: function () {
      if (this.validation()) return;

      this.fetchRequest({
        url: this.callback,
        form: this.form({
          ...this.data,
          phone: this.createPhone(this.data.phone),
        }),
        success: (data) => {
          console.log('success', data);
          if (data.body.success) {
            this.toogleCallBackForm();
            this.toogleConfirmBlock({
              title: 'Спасибо.',
              text: 'Наш менеджер свяжется с Вами в ближайшее время',
            });
          }
        },
        error: (e) => {
          console.log('error', e);
        },
      });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/templates/components/right-menu/ui/callback.vue